import AutomaticFaultReportingIcon from './component'

export default AutomaticFaultReportingIcon
